export const gearTierData: { tier: 'Advanced' | 'Expert' | 'Elite' | 'Master', baseTypes: string[] }[] = [
  {
    tier: 'Advanced',
    baseTypes: [
      // Bows
      "Artillery Bow",
      "Tribal Bow",
      "Adherent Bow",
      "Militant Bow",
      // Crossbows
      "Blackfire Crossbow",
      "Piercing Crossbow",
      "Twin Crossbow",
      "Cannonade Crossbow",
      "Bleak Crossbow",
      // Foci
      "Runed Focus",
      "Whorl Focus",
      "Arrayed Focus",
      "Cultist Focus",
      "Hallowed Focus",
      // One Hand Maces
      "Kalguuran Forgehammer",
      "Morning Star",
      "Jade Club",
      "Marching Mace",
      "Bandit Mace",
      "Structured Hammer",
      // Quivers
      "Serrated Quiver",
      "Toxic Quiver",
      // Quarterstaves
      "Hefty Quarterstaff",
      "Smooth Quarterstaff",
      "Waxing Quarterstaff",
      "Bladed Quarterstaff",
      "Guardian Quarterstaff",
      // Sceptres
      // Spears
      "Branched Spear",
      "Jagged Spear",
      "Massive Spear",
      "Helix Spear",
      "Seaglass Spear",
      "Crossblade Spear",
      // Staves
      // Talismans
      "Lumbering Talisman",
      "Voltfang Talisman",
      "Howling Talisman",
      "Fury Talisman",
      "Cruel Talisman",
      "Roaring Talisman",
      "Condemned Talisman",
      "Wingbeat Talisman",
      // Two Hand Maces
      "Pointed Maul",
      "Totemic Greatclub",
      "Solemn Maul",
      "Heavy Greathammer",
      "Disintegrating Maul",
      // Wands
      // Body Armours - Arm
      "Juggernaut Plate",
      "Chieftain Cuirass",
      "Elegant Plate",
      "Heavy Plate",
      "Stone Cuirass",
      // Body Armours - Eva
      "Corsair Vest",
      "Smuggler Coat",
      "Layered Vest",
      "Runner Vest",
      "Lizardscale Coat",
      // Body Armours - ES
      "Elementalist Robe",
      "Mystic Raiment",
      "River Raiment",
      "Adherent's Raiment",
      "Ceremonial Robe",
      // Body Armours - Arm/Eva
      "Knight Armour",
      "Ancestral Mail",
      "Mantled Mail",
      "Trailblazer Armour",
      "Golden Mail",
      // Body Armours - Arm/ES
      "Cleric Vestments",
      "Tideseer Mantle",
      "Occultist Mantle",
      "Plated Vestments",
      "Heartcarver Mantle",
      // Body Armours - Eva/Es
      "Scoundrel Jacket",
      "Itinerant Jacket",
      "Hatungo Garb",
      "Hawker's Jacket",
      // Helmets - Arm
      "Commander Greathelm",
      "Fierce Greathelm",
      "Elegant Greathelm",
      "Noble Greathelm",
      // Helmets - Eva
      "Corsair Cap",
      "Leatherbound Hood",
      "Wrapped Cap",
      "Deerstalker Hood",
      // Helmets - ES
      "Vermeil Circlet",
      "Jade Tiara",
      "Sandsworn Tiara",
      "Jungle Tiara",
      // Helmets - Arm/Eva
      "Closed Helm",
      "Cabalist Helm",
      "Cassis Helm",
      // Helmets - Arm/ES
      "Spiritbone Crown",
      "Hallowed Crown",
      "Inquisitor Crown",
      // Helmets - Eva/Es
      "Solid Mask",
      "Pariah Mask",
      "Avian Mask",
      // Gloves - Arm
      "Detailed Mitts",
      "Ancient Mitts",
      "Feathered Mitts",
      // Gloves - Eva
      "Fine Bracers",
      "Refined Bracers",
      "Spiked Bracers",
      // Gloves - ES
      "Pauascale Gloves",
      "Baroque Gloves",
      "Gold Gloves",
      // Gloves - Arm/Eva
      "Plate Gauntlets",
      "Zealot Gauntlets",
      // Gloves - Arm/ES
      "Kalguuran Cuffs",
      "Ornate Cuffs",
      // Gloves - Eva/Es
      "Buckled Wraps",
      "Adorned Wraps",
      // Boots - Arm
      "Reefsteel Greaves",
      "Elegant Greaves",
      "Carved Greaves",
      // Boots - Eva
      "Flared Boots",
      "Studded Boots",
      "Serpentscale Boots",
      // Boots - ES
      "Flax Sandals",
      "Elegant Slippers",
      "Dunerunner Sandals",
      // Boots - Arm/Eva
      "Covered Sabatons",
      "Bastion Sabatons",
      // Boots - Arm/ES
      "Weaver Leggings",
      "Shamanistic Leggings",
      // Boots - Eva/Es
      "Steelpoint Shoes",
      "Treerunner Shoes",
      // Shields - Arm
      "Crucible Tower Shield",
      "Ancestor Tower Shield",
      "Bulwark Tower Shield",
      "Noble Tower Shield",
      "Goldworked Tower Shield",
      // Shields - Arm/Eva
      "Stratified Targe",
      "Carved Targe",
      "Polished Targe",
      "Stone Targe",
      "Avian Targe",
      // Shields - Arm/ES
      "Wayward Crest Shield",
      "Seer Crest Shield",
      "Dekharan Crest Shield",
      "Quartered Crest Shield",
      "Glowering Crest Shield",
      // Bucklers
      "Laminate Buckler",
      "Pearl Buckler",
      "Spikeward Buckler",
      "Jingling Buckler",
      "Ornate Buckler",
    ],
  },
  {
    tier: 'Expert',
    baseTypes: [
      // Bows
      "Ironwood Shortbow",
      "Cavalry Bow",
      "Fanatic Bow",
      "Twin Bow",
      "Guardian Bow",
      // Crossbows
      "Stout Crossbow",
      "Engraved Crossbow",
      "Flexed Crossbow",
      "Elegant Crossbow",
      // Foci
      "Druidic Focus",
      "Leyline Focus",
      // One Hand Maces
      "Crown Mace",
      "Molten Hammer",
      "Strife Pick",
      "Fortified Hammer",
      "Akoyan Club",
      // Quivers
      "Two-Point Quiver",
      "Penetrating Quiver",
      "Volant Quiver",
      "Primed Quiver",
      // Quarterstaves
      "Bolting Quarterstaff",
      "Aegis Quarterstaff",
      "Dreaming Quarterstaff",
      // Sceptres
      // Spears
      "Orichalcum Spear",
      "Stalking Spear",
      "Spiked Spear",
      "Guardian Spear",
      // Staves
      // Talismans
      "Ashbark Talisman",
      "Fang Talisman",
      "Fungal Talisman",
      "Alpha Talisman",
      "Wildwood Talisman",
      "Thunder Talisman",
      // Two Hand Maces
      "Anvil Maul",
      "Ruination Maul",
      "Fanatic Greathammer",
      "Tawhoan Greatclub",
      // Wands
      "Attuned Wand",
      "Siphoning Wand",
      "Galvanic Wand",
      // Body Armours - Arm
      "Utzaal Cuirass",
      // Body Armours - Eva
      "Swiftstalker Coat",
      "Wyrmscale Coat",
      // Body Armours - ES
      // Body Armours - Arm/Eva
      // Body Armours - Arm/ES
      // Body Armours - Eva/Es
      // Helmets - Arm
      "Warmonger Greathelm",
      "Masked Greathelm",
      "Paragon Greathelm",
      // Helmets - Eva
      "Woven Cap",
      "Desert Cap",
      "Trapper Hood",
      // Helmets - ES
      "Skycrown Tiara",
      "Sorcerous Tiara",
      // Helmets - Arm/Eva
      "Warded Helm",
      "Cryptic Helm",
      "Champion Helm",
      // Helmets - Arm/ES
      "Druidic Crown",
      "Saintly Crown",
      "Divine Crown",
      // Helmets - Eva/Es
      "Brigand Mask",
      "Faridun Mask",
      "Soaring Mask",
      // Gloves - Arm
      "Knightly Mitts",
      "Ornate Mitts",
      "Vaal Mitts",
      // Gloves - Eva
      "Stalking Bracers",
      "Grand Bracers",
      "Barbed Bracers",
      // Gloves - ES
      "Grim Gloves",
      "Opulent Gloves",
      // Gloves - Arm/Eva
      "Steelmail Gauntlets",
      "Commander Gauntlets",
      "Cultist Gauntlets",
      // Gloves - Arm/ES
      "Bound Cuffs",
      "Ancient Cuffs",
      "Gleaming Cuffs",
      // Gloves - Eva/Es
      "War Wraps",
      "Elegant Wraps",
      "Vaal Wraps",
      // Boots - Arm
      "Bulwark Greaves",
      "Ornate Greaves",
      "Vaal Greaves",
      // Boots - Eva
      "Cinched Boots",
      "Cavalry Boots",
      // Boots - ES
      "Bound Sandals",
      // Boots - Arm/Eva
      "Veteran Sabatons",
      "Noble Sabatons",
      "Fortress Sabatons",
      // Boots - Arm/ES
      "Faithful Leggings",
      "Apostle Leggings",
      "Warlock Leggings",
      // Boots - Eva/Es
      "Wanderer Shoes",
      // Shields - Arm
      "Royal Tower Shield",
      "Fortress Tower Shield",
      // Shields - Arm/Eva
      "Mammoth Targe",
      "Baroque Targe",
      "Soaring Targe",
      // Shields - Arm/ES
      "Intricate Crest Shield",
      "Sekheman Crest Shield",
      "Vaal Crest Shield",
      // Bucklers
      "Bladeguard Buckler",
      "Gutspike Buckler",
      "Ancient Buckler",
    ],
  },
  {
    tier: 'Elite',
    baseTypes: [
      // Bows
      "Gemini Bow",
      // Crossbows
      "Siege Crossbow",
      "Desolate Crossbow",
      "Trarthan Cannon", // 0.5
      "Gemini Crossbow",
      // Foci
      "Sacred Focus",
      // One Hand Maces
      "Marauding Mace",
      // Quivers
      "Visceral Quiver",
      // Quarterstaves
      "Razor Quarterstaff",
      "Lunar Quarterstaff",
      "Skullcrusher Quarterstaff",
      "Striking Quarterstaff",
      // Sceptres
      "Stoic Sceptre",
      "Omen Sceptre",
      "Wrath Sceptre",
      "Rattling Sceptre",
      "Shrine Sceptre",
      // Spears
      "Grand Spear",
      "Flying Spear",
      "Pronged Spear",
      "Soaring Spear",
      // Staves
      "Ashen Staff",
      "Pyrophyte Staff",
      "Reaping Staff",
      "Roaring Staff",
      "Voltaic Staff",
      "Chiming Staff",
      "Paralysing Staff",
      "Sanctified Staff",
      // Talismans
      "Maji Talisman",
      "Jade Talisman",
      // Two Hand Maces
      "Massive Greathammer",
      "Sacred Maul",
      "Ironwood Greathammer",
      // Wands
      "Withered Wand",
      "Bone Wand",
      "Volatile Wand",
      // Body Armours - Arm
      "Soldier Cuirass",
      "Ornate Plate",
      "Warlord Cuirass",
      // Body Armours - Eva
      "Corsair Coat",
      // Body Armours - ES
      "Flowing Raiment",
      "Sacramental Robe",
      "Feathered Raiment",
      // Body Armours - Arm/Eva
      "Dastard Armour",
      "Shrouded Mail",
      "Death Mail",
      "Thane Mail",
      // Body Armours - Arm/ES
      "Wolfskin Mantle",
      "Conjurer Mantle",
      "Death Mantle",
      "Seastorm Mantle",
      // Body Armours - Eva/Es
      "Rambler Jacket",
      "Falconer's Jacket",
      "Austere Garb",
      // Helmets - Arm
      "Imperial Greathelm",
      // Helmets - Eva
      "Freebooter Cap",
      // Helmets - ES
      "Kamasan Tiara",
      // Helmets - Arm/Eva
      "Gladiatorial Helm",
      // Helmets - Arm/ES
      "Cryptic Crown",
      // Helmets - Eva/Es
      "Grinning Mask",
      // Gloves - Arm
      "Massive Mitts",
      // Gloves - Eva
      "Polished Bracers",
      // Gloves - ES
      "Vaal Gloves",
      // Gloves - Arm/Eva
      "Blacksteel Gauntlets",
      // Gloves - Arm/ES
      "Adherent Cuffs",
      // Gloves - Eva/Es
      "Secured Wraps",
      // Boots - Arm
      "Tasalian Greaves",
      // Boots - Eva
      "Dragonscale Boots",
      // Boots - ES
      "Luxurious Slippers",
      // Boots - Arm/Eva
      "Blacksteel Sabatons",
      // Boots - Arm/ES
      "Cryptic Leggings",
      // Boots - Eva/Es
      "Charmed Shoes",
      // Shields - Arm
      "Vaal Tower Shield",
      // Shields - Arm/Eva
      "Golden Targe",
      // Shields - Arm/ES
      "Blacksteel Crest Shield",
      // Bucklers
      "Desert Buckler",
    ],
  },
  {
    tier: 'Master',
    baseTypes: [
      // Bows
      "Warmonger Bow",
      "Obliterator Bow",
      // Crossbows
      // Foci
      "Tasalian Focus",
      // One Hand Maces
      "Flanged Mace",
      // Quivers
      // Quarterstaves
      "Sinister Quarterstaff",
      // Sceptres
      // Spears
      "Akoyan Spear",
      // Staves
      "Gelid Staff",
      // Talismans
      "Spiny Talisman",
      // Two Hand Maces
      // Wands
      "Dueling Wand",
      // Body Armours - Arm
      // Body Armours - Eva
      "Slipstrike Vest",
      // Body Armours - ES
      "Vile Robe",
      // Body Armours - Arm/Eva
      // Body Armours - Arm/ES
      // Body Armours - Eva/Es
      "Sleek Jacket",
      // Helmets - Arm
      // Helmets - Eva
      // Helmets - ES
      "Ancestral Tiara",
      // Helmets - Arm/Eva
      // Helmets - Arm/ES
      // Helmets - Eva/Es
      // Gloves - Arm
      // Gloves - Eva
      // Gloves - ES
      "Sirenscale Gloves",
      // Gloves - Arm/Eva
      // Gloves - Arm/ES
      // Gloves - Eva/Es
      // Boots - Arm
      // Boots - Eva
      "Drakeskin Boots",
      // Boots - ES
      "Sandsworn Sandals",
      "Sekhema Sandals",
      // Boots - Arm/Eva
      // Boots - Arm/ES
      // Boots - Eva/Es
      "Quickslip Shoes",
      "Daggerfoot Shoes",
      // Shields - Arm
      "Tawhoan Tower Shield",
      // Shields - Arm/Eva
      // Shields - Arm/ES
      // Bucklers
    ],
  },
];
